<template lang="pug">
div.spokesman
  ul
    li(v-for="(spokeman,$index) in spokemans", :key="$index")
      figure
        img(:src="spokeman.url")
      div.information
        h4.name {{spokeman.nameZh}}
        p.role  {{spokeman.role}}
        p.desc(:title="spokeman.descZh")  {{spokeman.descZh}}
  //- div.more
    a(href="#")
      button.button Meet the Punks & Poets
</template>
<script>
let spokemans = require('../../assets/starsDetails.json')
spokemans = spokemans.map(d => {
  return {
    ...d,
    url: 'http://stance.oss-cn-hangzhou.aliyuncs.com/images/stars/' + d.name + '.jpg'
  }
})
export default {
  name: 'SpokenMan',
  data () {
    return {
      spokemans: spokemans
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/common.scss";
.spokesman {
  margin-top: 80px;
}
ul {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 0;
  padding:0;
  li {
    width: 50%;
    overflow: hidden;
    padding: 0 15px;
    figure {
      height: 40vw;
      width: 100%;
      overflow: hidden;
      img {
        height: 100%;
        object-position: 33.72% 35.35%;
      }
    }
  }
}

.information {
  text-align: left;
  margin-bottom: 15px;
  h4 {
    color:#1a1a1a;
    font-size: 1.43rem;
    font-family: akzidenz-grotesk-condensed;
    font-weight: 400;
    line-height: 1.1;
    color: #1a1a1a;
    text-transform: uppercase;
    margin-top: 20px;
    margin-bottom: 0;
  }
  p {
    margin: 10px 0;
  }
  p.role {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 12px;
  }
  p.desc {
    text-align: left;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    margin-bottom: 20px;
  }
}

.more {
  text-align: center;
  margin-top: 1.25rem;
  margin-bottom: 3.75rem;
  button {
    @extend %button;
  }
}

@media only screen and (min-width: 768px) {
.spokesman {
  max-width: 80rem;
  margin: 80px  auto 0 auto;
}
 ul li  {
  width: 25%;
  figure {
    height: 18vw;
    max-height: 212px;
  }
 }
}
</style>
